import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
	selector: 'app-cappy-loader',
	imports: [ CommonModule],
	templateUrl: './cappy-loader.html',
	styleUrl: './cappy-loader.scss',
	animations: [
		trigger('fadeInOut', [
			transition(':enter', [
				style({ opacity: 0 }),
				animate('300ms ease-in', style({ opacity: 1 }))
			]),
			transition(':leave', [
				animate('300ms ease-out', style({ opacity: 0 }))
			])
		])
	]
})
export class CappyLoader {
	public showLoader: boolean = false;
	@Input() viewType: 'REGULAR_LOADING' | 'TABLE_LOADING' = 'REGULAR_LOADING';
	@Input() verbiage: string | null = null;
	constructor() {

	}

}
